import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Collapse from 'antd/lib/collapse';
import PenaltyFeeCollapseList from './PenaltyFeeCollapseList';

const CollapsePanel = Collapse.Panel;

const PenaltyFeeCollapse = ({ items, loanId,t }) => (
  <Collapse>
    <CollapsePanel header={t('Sankčné poplatky')}>
      <PenaltyFeeCollapseList items={items} loanId={loanId}/>
    </CollapsePanel>
  </Collapse>
);

PenaltyFeeCollapse.propTypes = {
  loanId: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(PenaltyFeeCollapse);



// WEBPACK FOOTER //
// ./src/features/penalty-fee/components/PenaltyFeeCollapse.js